/**
 * Build identity baked in at build time (see vite.config.ts `define`).
 * Shown in the footer version pill and compared with `server:hello.buildSha`
 * to detect a tab that is older than the deployed server.
 */
export const BUILD_SHA: string = __BUILD_SHA__;
export const BUILD_TIME: string = __BUILD_TIME__;

/** "24 Sep 2026" — the build date for the version pill (UTC, locale-independent). */
export function formatBuildDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${d.getUTCDate()} ${months[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}

/**
 * True when the server runs a different build than this tab. `dev` (no git
 * available) on either side is not comparable, so it never triggers a reload
 * prompt.
 */
export function isBuildMismatch(clientSha: string, serverSha: string | null | undefined): boolean {
  if (!serverSha) return false;
  if (clientSha === 'dev' || serverSha === 'dev') return false;
  return clientSha !== serverSha;
}
